/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Payment_Link_ResentInputs */

const en_orders_payment_link_resent = /** @type {(inputs: Orders_Payment_Link_ResentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment link resend logged.`)
};

const es_orders_payment_link_resent = /** @type {(inputs: Orders_Payment_Link_ResentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenvio de link de pago registrado.`)
};

/**
* | output |
* | --- |
* | "Payment link resend logged." |
*
* @param {Orders_Payment_Link_ResentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_payment_link_resent = /** @type {((inputs?: Orders_Payment_Link_ResentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Payment_Link_ResentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_payment_link_resent(inputs)
	return es_orders_payment_link_resent(inputs)
});